import { createSlice } from "@reduxjs/toolkit";

export const twilioInfoSlice = createSlice({
  name: "twilioInfo",
  initialState: {
    activeGlobalRoom: null,
    activeBoxRoom: null,
    activeGlobalTrack: null,
    activeBoxTrack: null,
  },

  reducers: {
    updateGlobalRoom: (state, action) => {
      const { room, track } = action.payload;
      return { ...state, activeGlobalRoom: room, activeGlobalTrack: track };
    },

    updateBoxRoom: (state, action) => {
      const { room, track } = action.payload;
      return { ...state, activeBoxRoom: room, activeBoxTrack: track };
    },
  },
});

export const { updateGlobalRoom, updateBoxRoom } = twilioInfoSlice.actions;

export default twilioInfoSlice.reducer;
